module.exports = __webpack_public_path__ + "d9878b58ded4ae7f0dab7b8f94901876.jpg";